import { put, call, take, fork } from 'redux-saga/effects'
import { collectionMemberFilterService } from '../../api/collection'
import { collectionMemberFilterSuccess } from '../../reducers/teams/action'
import { COLLECTION_MEMBER_FILTER } from '../../reducers/teams/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* collectionMemberFilterFlow(payload) {
  try {
    const { id, data, callback } = payload

    const response = yield call(collectionMemberFilterService, id, data)
    yield put(collectionMemberFilterSuccess(response.data))
    yield put(operationSuccess())

    if (callback) {
      callback(response.data.results)
    }
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* collectionMemberFilterWatcher() {
  while (true) {
    const action = yield take(COLLECTION_MEMBER_FILTER)
    const { payload } = action

    yield fork(generalSaga, collectionMemberFilterFlow, payload, false)
  }
}
